import { render, staticRenderFns } from "./CardBlogSmall.vue?vue&type=template&id=70e37b34&"
import script from "./CardBlogSmall.vue?vue&type=script&lang=js&"
export * from "./CardBlogSmall.vue?vue&type=script&lang=js&"
import style0 from "./CardBlogSmall.vue?vue&type=style&index=0&id=70e37b34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports